<aura-dialog-layout [title]="'Justificatif de propriété non renseigné'" [hideCancel]="true">
  <div dialog-content class="flex flex-col gap-4 py-2">
    <!-- Notice box with shield icon -->
    <div class="flex items-start gap-3.5 rounded-xl border border-amber-6 bg-amber-2/50 p-4">
      <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-amber-3 text-amber-11">
        <mat-icon class="text-xl">shield</mat-icon>
      </div>
      <div class="flex-1">
        <h3 class="text-sm font-semibold text-gray-12 m-0">Document obligatoire pour la diffusion</h3>
        <p class="mt-1 text-xs text-gray-11 leading-relaxed m-0">
          Pour garantir la sécurité des transactions et certifier votre bien, la transmission de votre
          <strong>titre de propriété</strong> ou <strong>taxe foncière</strong> est indispensable.
        </p>
      </div>
    </div>

    <!-- Explanation point -->
    <p class="text-xs text-gray-11 leading-relaxed m-0">
      Sans ce justificatif validé par nos équipes, votre annonce
      <strong>ne pourra pas être diffusée auprès des agents immobiliers partenaires</strong>. Vous pouvez
      toutefois finaliser la création maintenant et ajouter ce document plus tard depuis la fiche de votre
      bien.
    </p>
  </div>

  <div
    dialog-actions
    class="flex flex-col-reverse sm:flex-row items-stretch sm:items-center justify-end gap-3 w-full pt-2"
  >
    <button mat-stroked-button type="button" (click)="onUploadNow()" class="flex-1 sm:flex-initial">
      <mat-icon class="text-base!">upload_file</mat-icon>
      <span>Téléverser mon justificatif</span>
    </button>

    <button
      mat-flat-button
      class="primary flex-1 sm:flex-initial flex items-center justify-center gap-1.5"
      type="button"
      (click)="onUploadLater()"
    >
      <span>Je le ferai plus tard</span>
      <mat-icon class="text-base!">arrow_forward</mat-icon>
    </button>
  </div>
</aura-dialog-layout>
